import React from 'react';
import { Flex, Stack } from '@mantine/core';
import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';

interface BaseScenarioLayoutProps {
  session: DeviceConfigurationApi;
  sessionBox: React.ReactNode;
  devicesBox: React.ReactNode;
  chartBox: React.ReactNode;
}

export const BaseScenarioLayout = React.memo<BaseScenarioLayoutProps>(
  ({ sessionBox, devicesBox, chartBox }) => {
    return (
      <>
        {/* Desktop Layout: Row */}
        <Flex
          gap='md'
          direction='row'
          style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}
          visibleFrom='lg'
        >
          <Flex
            w='30%'
            miw='30%'
            direction='column'
            gap='md'
            style={{ overflow: 'hidden', minHeight: 0 }}
          >
            <Stack gap='sm' style={{ flexShrink: 0 }}>
              {sessionBox}
            </Stack>

            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
              {devicesBox}
            </div>
          </Flex>

          <Flex w='70%' style={{ minHeight: 0 }}>
            {chartBox}
          </Flex>
        </Flex>

        {/* Mobile Layout: Column (Session -> Chart -> Devices) */}
        <Stack
          gap='md'
          style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}
          hiddenFrom='lg'
        >
          {sessionBox}
          {chartBox}
          {devicesBox}
        </Stack>
      </>
    );
  }
);

BaseScenarioLayout.displayName = 'BaseScenarioLayout';
